import Alpine from 'alpinejs';
import { SimpleAutocompleteResult } from "../autocomplete/types";
import { City, storeLocatorAutocomplete } from '../../scripts/helpers/storeLocator';
import { AlpineComponentTryba } from '../../scripts/alpine/include/global';

const privateProperties  = {
    _url: window.location.origin + '/api/insee/',
}

const publicProperties: Record<string, any> = {
    results: [],
    nbInputs: null,
    displayResultsWording: false,
    noResults: false,
    tooShort: false,
    tooLong: false,
    modal: false,
    loading: false,
}

document.addEventListener('alpine:init', () => {
    Alpine.data('simpleAutocompleteFilleul', (): AlpineComponentTryba => {
        return {
            ...privateProperties,
            ...publicProperties,
            //Make api call with inputs and check if there are errors
            validateInput(event: any) {
                const targetValue = event.target.value.trim();
                if (targetValue !== '') {
                    this.nbInputs = targetValue.length;
                    this.modal = true;
                    if (!isNaN(targetValue)) {
                        if (this.nbInputs == 0) {
                            this.disabled = true;
                        }
                        if (this.nbInputs > 5) {
                            this.noResults = false;
                            this.tooLong = true;
                            return;
                        }
                    }
                    // fetch(this._url + event.target.value)
                    //     .then(async (response: Response) => {
                    //         this.results = await response.json();
                    //     })
                    //     .then(() => {
                    //         this.displayResults(); this.displayResults();
                    //     })
                    //     .catch(() => {
                    //         this.results = [];
                    //         this.displayResultsWording = false;
                    //         this.noResults = true;
                    //     });

                    storeLocatorAutocomplete(targetValue.replace(/-/g, ' '))
                        .then((cities) => {
                            console.log(cities);
                            (this.results as Array<City>) = cities;
                        })
                        .then(() => {
                            this.overlayPage = true;
                            this.displayResults();
                        })
                        .catch((error) => {
                            console.error("Error fetching autocomplete results:", error);
                            this.results = []
                            this.noResults = true;
                    });
                }
            },
            setCityInBasicForm(selectedItem: SimpleAutocompleteResult, domItem: HTMLElement) {
                try {
                    const actualForm = domItem.closest('[x-data]')
                    if(actualForm) {
                        const zipInput = actualForm.querySelector<HTMLInputElement>('[name$="[zip]"]');
                        if (zipInput) {
                            zipInput.value = selectedItem.codesPostaux[0];
                            this.validateField(zipInput)
                        }
                        const cityInput = actualForm.querySelector<HTMLInputElement>('[name$="[city]"]');
                        if(cityInput) {
                            cityInput.value = selectedItem.nom;
                            this.validateField(cityInput);
                        }
                    }
                } catch (e) {
                    // noop
                }
                this.closeModal();
            },
            //Display list of results
            displayResults() {
                this.results = JSON.parse(JSON.stringify(this.results));
                this.modal = true;

                if (this.results.length) {
                    this.tooLong = false;
                    this.tooShort = false;
                    this.noResults = false;
                    this.displayResultsWording = true;
                } else {
                    //No results
                    if (this.nbInputs >= 1) {
                        this.noResults = true;
                        this.tooShort = false;
                        this.tooLong = false;
                    }

                    this.displayResultsWording = false;
                }
            },
            //Open modal
            openModal() {
                this.modal = true;
                this.displayResults();
            },
            //Close modal on click outside
            closeModal() {
                this.modal = false;
            },
        };
    });
});
